import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";

export const useCaptcha = () => {
  const [captcha, setCaptcha] = useState(null);
  const reload = useCallback(async () => {
    setCaptcha(null);
    try {
      const { data } = await api.get("/captcha");
      setCaptcha(data);
    } catch {
      setCaptcha({ error: true });
    }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { captcha, reload };
};

export const CaptchaField = ({ captcha, reload, value, onChange }) => {
  const { t } = useI18n();
  return (
    <div className="space-y-2">
      <Label htmlFor="captcha" className="text-sm text-[#F0F6FC]">{t("fCaptcha")}</Label>
      <div className="flex flex-wrap items-center gap-3">
        <div className="h-[70px] w-[200px] rounded-lg overflow-hidden bg-white border border-[#30363D] flex items-center justify-center">
          {captcha?.image
            ? <img src={captcha.image} alt="captcha" data-testid="captcha-image" className="h-full w-full" />
            : <span className="text-xs text-[#6E7681]">{captcha?.error ? t("captchaFail") : "…"}</span>}
        </div>
        <button type="button" onClick={reload} data-testid="captcha-refresh-btn" aria-label={t("captchaRefresh")}
          className="h-10 w-10 rounded-full border border-[#30363D] flex items-center justify-center text-[#8B949E] hover:text-[#F0F6FC] hover:bg-[#21262D] transition-colors">
          <RefreshCw className="h-4 w-4" />
        </button>
        <Input id="captcha" data-testid="register-captcha-input" value={value} onChange={onChange} maxLength={5}
          placeholder={t("captchaPh")} autoComplete="off"
          className="h-12 flex-1 min-w-[140px] bg-[#0D1117] border-[#30363D] focus-visible:ring-[#3FB950] font-mono uppercase tracking-[0.3em]" />
      </div>
    </div>
  );
};
